import ViewTransferRequisition from "../../../../components/@documents/transfer_requisitions/ViewTransferRequisition";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferRequisitionViewPage() {

    return (
        <ViewTransferRequisition 
            routeType={routeTypes.admin}
        />
    )
}